import React from "react";
import Image from "next/image";

const ProgramResult = ({ data, onButtonClick }) => {
  return (
    <section className="py-sp-100 sm:py-sp-big bg-[#F0F7FF]">
      <div className="container px-3">
        <h2 className="text-center text-textxl sm:text-xl font-medium text-baseBlack mb-5">
          {data?.heading}
        </h2>

        <div className="flex flex-wrap items-center gap-5 sm:gap-2">
          {data?.whySection?.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center w-[30%] sm:w-[47%]"
            >
              <Image
                src={item.image}
                alt={item.text}
                width={120}
                height={120}
              />

              <h3 className="text-baseBlack text-base2 font-medium sm:text-sm">
                {item.text}
              </h3>
              {item.text2 &&
              <p className="text-baseBlack text-base sm:text-sm mt-xsp w-3/4 sm:w-full">
                {item.text2}
              </p>}
            </div>
          ))}
        </div>

        {/* Button */}
        {data?.btntext && (
          <div className="flex justify-center mt-12">
            <button
              className="py-2 px-4 rounded-full text-white text-base font-normal w-fit bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C] flex gap-x-1 justify-center items-center"
              type="button"
              onClick={onButtonClick}
            >
              {data?.btntext}
              <svg
                xmlns="https://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="brand"
                width="24"
                height="24"
                className="fill-current text-white"
              >
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
              </svg>
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProgramResult;
